import { FormErrorTypes, IPriceRange, validatePrice } from 'dash-ui';
import {
  DashValidation,
  isEmptyOrNil,
  isNameLengthValid,
  isUrlValid,
} from 'dash-common';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { FormContext } from 'dash-ui';

import { FormFields } from 'containers/properties/PropertyGeneralInformation/components/PropertyGeneralInfoForm/constants/constants';

const useValidation = () => {
  const { errorHandlers } = useContext(FormContext);
  const { t } = useTranslation(['forms', 'common', 'pages']);

  const resetPricesErrors = () => {
    errorHandlers[FormFields.Prices](null);
  };

  const validateFieldByName = (
    fieldName: FormFields,
    value: string | IPriceRange | any[]
  ) => {
    const setInvalid = (message: string) => {
      errorHandlers[fieldName]({
        type: FormErrorTypes.Invalid,
        message: t(message),
      });
    };

    // check specific fields type
    switch (fieldName) {
      case FormFields.Name: {
        if (isEmptyOrNil(value as string)) {
          setInvalid(`forms:messages.nameBlank`);
          return false;
        }
        if (!isNameLengthValid(value as string)) {
          setInvalid(`forms:messages.nameInvalid`);
          return false;
        }
        break;
      }
      case FormFields.DefaultInventoryDetails: {
        if (String(value).length > DashValidation.MaxNameLength) {
          setInvalid('forms:messages.fieldLengthInvalid');
          return false;
        }
        break;
      }
      case FormFields.Website: {
        if (value && !isUrlValid(value as string)) {
          setInvalid('forms:messages.urlInvalid');
          return false;
        }
        break;
      }
      case FormFields.Prices: {
        const { min, max } = value as IPriceRange;
        if (!validatePrice(min, max)) {
          setInvalid('forms:messages.startingPriceMoreThanHighest');
          return false;
        }
        resetPricesErrors();
        break;
      }
    }
    errorHandlers[fieldName](null);
    return true;
  };

  return validateFieldByName;
};

export default useValidation;
